import MemModel from '@/models/Mem';

const GET_OFFICIAL_ACCOUNTS_IMAGE = 'GET_OFFICIAL_ACCOUNTS_IMAGE';

/**
 * 获取个人中心公众号关注图片
 */
async function getOfficialAccountsImage() {
  const payload = await new MemModel().getOfficialAccountsImage();
  return {
    type: GET_OFFICIAL_ACCOUNTS_IMAGE,
    payload
  }
}

const ACTION_TYPES = {
  GET_OFFICIAL_ACCOUNTS_IMAGE,
};

const ACTION = {
  getOfficialAccountsImage,
};

const UserRecommend = {
  ACTION_TYPES,
  ACTION
}

export default UserRecommend;